var React = require('react');

function Compass (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","fill":"black","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.0824 9.9176L11.0534 11.0535L9.91759 14.0824L12.9465 12.9465L14.0824 9.9176ZM15.4401 7.27247L10.3512 9.1808C9.81036 9.38362 9.38361 9.81036 9.18079 10.3512L7.27246 15.4401C6.97101 16.244 7.75603 17.029 8.55992 16.7275L13.6488 14.8192C14.1896 14.6164 14.6164 14.1896 14.8192 13.6488L16.7275 8.55992C17.029 7.75604 16.244 6.97101 15.4401 7.27247Z","fill":"black","key":1})]);
}

Compass.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Compass;

Compass.default = Compass;
